import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor() { }

  getVersion(): string {
    return environment.version;
  }
}
